export default __webpack_public_path__ + "static/media/pencil.466eab12.svg";